// Desktop nav dropdown — hover open/close.
//
// Fix (2026-08-15): the previous version closed the dropdown the instant the
// cursor left the <details> element's box (immediate mouseleave, no delay).
// Because the submenu is positioned outside normal flow, any brief gap or
// imprecise diagonal mouse movement between the parent nav item and the
// dropdown caused it to snap shut before the cursor ever reached it. The
// previous version also re-attached a new mouseleave listener on every
// single mouseover instead of binding once, stacking duplicate listeners.
//
// This version binds each listener exactly once per menu item, and closes
// on a short delay (200ms) that gets cancelled if the cursor re-enters
// either the parent item or the dropdown before it fires. That's what makes
// the dropdown forgiving of the gap: as long as the cursor reaches the
// dropdown within ~200ms of leaving the parent, it never closes.
(function () {
  var container = document.querySelector('.header__inline-menu');
  if (!container) return;

  container.querySelectorAll('details').forEach(function (menuItem) {
    var submenu = menuItem.querySelector('ul');
    var closeTimer = null;

    function openMenu() {
      clearTimeout(closeTimer);
      menuItem.setAttribute('open', '');
    }

    function scheduleClose() {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        menuItem.removeAttribute('open');
      }, 200);
    }

    menuItem.addEventListener('mouseenter', openMenu);
    menuItem.addEventListener('mouseleave', scheduleClose);

    // Bound separately (not just relying on descendant bubbling) so that
    // moving between the parent item and the dropdown, or around within the
    // dropdown itself, always cancels any pending close — belt and braces
    // alongside the delay above.
    if (submenu) {
      submenu.addEventListener('mouseenter', openMenu);
      submenu.addEventListener('mouseleave', scheduleClose);
    }
  });

  // Keyboard and click behavior (Tab, Enter, Escape, focus-out close) are
  // handled elsewhere by the header-menu / details-disclosure custom
  // elements in details-disclosure.js — intentionally untouched here.
})();

document.addEventListener("DOMContentLoaded", function() {
  if (window.innerWidth > 749) return; // Mobile only

  const bodyBlocks = document.querySelectorAll(
    "body .rte:not(header .rte):not(footer .rte):not(#shopify-section-template--24338094915900__image_banner .rte)"
  );

  bodyBlocks.forEach(block => {
    if (block.dataset.readMoreProcessed) return;

    const paragraphs = block.querySelectorAll("p");

    if (paragraphs.length > 1) {
      // Hide all paragraphs after the first
      const hiddenParas = [];
      paragraphs.forEach((p, index) => {
        if (index === 0) return;
        p.classList.add("read-more-content");
        hiddenParas.push(p);
      });

      // Create Read More button and insert after first paragraph
      const btn = document.createElement("span");
      btn.className = "read-more-btn";
      btn.textContent = "Read More";
      paragraphs[0].after(btn);

      // Move the button **inside hidden content** when expanded for Read Less
      block.dataset.readMoreProcessed = "true";
    }
  });

  // Toggle hidden paragraphs
  document.addEventListener("click", function(e) {
    if (!e.target.classList.contains("read-more-btn")) return;

    const btn = e.target;
    const block = btn.closest(".rte");
    const hiddenParas = block.querySelectorAll(".read-more-content");

    if (hiddenParas.length === 0) return;

    if (hiddenParas[0].style.display === "block") {
      // Hide hidden paragraphs
      hiddenParas.forEach(p => p.style.display = "none");
      // Move button back after first paragraph
      block.querySelector("p").after(btn);
      btn.textContent = "Read More";
    } else {
      // Show hidden paragraphs
      hiddenParas.forEach(p => p.style.display = "block");
      // Move button after last hidden paragraph
      hiddenParas[hiddenParas.length - 1].after(btn);
      btn.textContent = "Read Less";
    }
  });
});
